import { render, staticRenderFns } from "./DialogEditRecebimentoDefinido.vue?vue&type=template&id=c0f2d2fa"
import script from "./DialogEditRecebimentoDefinido.vue?vue&type=script&lang=js"
export * from "./DialogEditRecebimentoDefinido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports